import httpClient from './api/httpClient';

const END_POINT = 'prematricula';
export const getOne = (id) => httpClient.get(END_POINT + '/arquivo/' + id, {responseType: "blob"});
export const rmvOne = (id) => httpClient.delete(END_POINT + '/arquivo/' + id);